import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const configListColumns = [
  'config.delete',
  'config.currency',
  'config.id',
  'config.providerId',
  'config.createdAt',
  'config.updatedAt',
  'config.betSuggestions',
  'config.maxWin',
  'config.defaultBet',
  'config.minBet',
  'config.maxBet',
  'config.defaultAutoCashout',
  'config.minAutoCashout',
  'config.maxAutoCashout',
  'config.isRoundable',
  'config.allowedBetType',
] as const;

export type ConfigListColumns = (typeof configListColumns)[number];

export type ConfigListFilter = {
  'config.delete': string | undefined;
  'config.currency': string | undefined;
  'config.id': string | undefined;
  'config.providerId': string | undefined;
  'config.createdAt': string | undefined;
  'config.updatedAt': string | undefined;
  'config.betSuggestions': number[] | undefined;
  'config.maxWin': number | undefined;
  'config.defaultBet': number | undefined;
  'config.minBet': number | undefined;
  'config.maxBet': number | undefined;
  'config.defaultAutoCashout': number | undefined;
  'config.minAutoCashout': number | undefined;
  'config.maxAutoCashout': number | undefined;
  'config.isRoundable': boolean | undefined;
  'config.allowedBetType': string | undefined;
};

export const defaultConfigListFilter: ConfigListFilter = {
  'config.delete': undefined,
  'config.currency': undefined,
  'config.id': undefined,
  'config.providerId': undefined,
  'config.createdAt': undefined,
  'config.updatedAt': undefined,
  'config.betSuggestions': undefined,
  'config.maxWin': undefined,
  'config.defaultBet': undefined,
  'config.minBet': undefined,
  'config.maxBet': undefined,
  'config.defaultAutoCashout': undefined,
  'config.minAutoCashout': undefined,
  'config.maxAutoCashout': undefined,
  'config.isRoundable': undefined,
  'config.allowedBetType': undefined,
};

export const configListColumnVisibilitySettings = {
  'config.delete': ColumnVisibilityType.CanBeHidden,
  'config.currency': ColumnVisibilityType.Visible,
  'config.id': ColumnVisibilityType.CanBeHidden,
  'config.providerId': ColumnVisibilityType.CanBeHidden,
  'config.createdAt': ColumnVisibilityType.CanBeHidden,
  'config.updatedAt': ColumnVisibilityType.CanBeHidden,
  'config.betSuggestions': ColumnVisibilityType.CanBeHidden,
  'config.maxWin': ColumnVisibilityType.CanBeHidden,
  'config.defaultBet': ColumnVisibilityType.CanBeHidden,
  'config.minBet': ColumnVisibilityType.CanBeHidden,
  'config.maxBet': ColumnVisibilityType.CanBeHidden,
  'config.defaultAutoCashout': ColumnVisibilityType.CanBeHidden,
  'config.minAutoCashout': ColumnVisibilityType.CanBeHidden,
  'config.maxAutoCashout': ColumnVisibilityType.CanBeHidden,
  'config.isRoundable': ColumnVisibilityType.CanBeHidden,
  'config.allowedBetType': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<ConfigListColumns>;

export const defaultConfigListColumnVisibility = defaultColumnVisibilityParams(
  configListColumnVisibilitySettings
);

export const configListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  configListColumns,
  configListColumnVisibilitySettings
);
